import { getDownloadURL, ref } from "firebase/storage";
import { firebaseStorage } from "../../../common/services/firebase";

const getSessionAudio = async (sessionId: string, filename: string) => {
	const pathReference = ref(firebaseStorage, `sessions/${sessionId}/${filename}`);
	return await getDownloadURL(pathReference);
};

export default getSessionAudio;
